export const skillColors = {
  angular: '#DD0031',
  javascript: '#f7df1e',
  typescript: '#007acc',
  css: '#1572b6',
  html: '#e44f26',
  webpack: '#8ed6fb',
  sass: '#cd6799',
  rxjs: '#d52085',
  git: '#f34f29'
} as const

export type SkillColors = typeof skillColors
export type SkillName = keyof SkillColors
